export * from './attributes.gmb';
export * from './attributes.malou';
